export default [
  {
    path: '/correios',
    name: 'app-correios-settings',
    component: () => import('@/views/apps/correios/CorreiosSettings.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Correios',
      action: 'read',
      resource: 'ADMIN_B2C',
      breadcrumb: [
        {
          text: 'Configurações',
          active: true,
        },
        {
          text: 'Correios',
          active: true,
        },
      ],
    },
  },
]
